import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import {RestApiService} from "../base-api/rest-api.service";

@Injectable()
export class TestService extends RestApiService {
  URL: string = "/tests/";

  constructor() {
    super();
  }

  getDetailsById(testId, searchCriteria?: SearchCriteria): Observable<Array<any>> {
    const URL = this.URL + testId + "/detail";

    return new Observable((observer) => {
      super.get(URL, searchCriteria)
        .subscribe(
          (response: any) => {
            observer.next(response.OrderResultDetails.Content);
            observer.complete();
          },
          ((error: any) => {
            observer.error(error);
            observer.complete();
          }));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/test/test.service.ts